import { DeliveryServicesContext } from '@/contexts/DeliveryServicesContext.jsx';
import { DeliveryServices, TextColorEnum } from '@desquared/wave-components-library';
import { GuestAddAddress } from '../GuestAddAddress/GuestAddAddress';
import React, { useContext, useEffect, useState } from 'react';
import { AddressViewSideSheetStore } from '@/store/sideSheet';
import { useTranslations } from 'next-intl';
import { constructAddressLine, setShopId, setShopIdByAddressLine } from '@/utils/products/products';
import User from '@/store/user.js';
import GuestUserStore from '@/store/guestUser';
import { useConfiguration } from '@/contexts/ConfigContext';
import { STREET_THEN_NUMBER, NUMBER_THEN_STREET } from '@/constants/addressFormat';

const menuList = undefined;

export default function DeliveryServicesSheet({ responsiveLogo }) {
  const [guestUser, setGuestUser] = useState();
  const t = useTranslations('common.asides.service_address.types');
  const { user, selectedUserAddressIndex, setSelectedUserAddressIndex, selectedService } =
    useContext(DeliveryServicesContext);
  const { config, requiresAddressLine } = useConfiguration();
  const addresses =
    user?.addresses.map((element, index) => {
      return {
        ...element,
        isAvailable: null,
        textColor: TextColorEnum.Gray1,
        isSelected: selectedUserAddressIndex === index,
        title: addressType(element.type),
        subTitle: addressName(element, config?.format?.addressStreetPattern),
      };
    }) || [];

  useEffect(() => {
    if (user && user?.addresses.length > 0) {
      if (selectedUserAddressIndex !== undefined) {
        const selectedAddressObj = User.getValue().addresses[selectedUserAddressIndex];
        if (requiresAddressLine) {
          setShopIdByAddressLine(
            constructAddressLine(selectedAddressObj),
            selectedService?.id,
            selectedAddressObj?.postalCode
          );
        } else {
          setShopId(selectedAddressObj?.postalCode, selectedService?.id);
        }
      } else {
        setSelectedUserAddressIndex(0);
      }
    }
    //eslint-disable-next
  }, []);

  useEffect(() => {
    const sub = GuestUserStore.subscribe(setGuestUser);

    return sub.unsubscribe();
  }, []);

  function addressType(s) {
    switch (s) {
      case 'home':
        return t('home');
      case 'work':
        return t('work');
      case 'other':
        return t('other');
    }
  }
  function addressName(s = {}, addressFormat = NUMBER_THEN_STREET) {
    const streetPart = (addressFormat === STREET_THEN_NUMBER ? [s?.street, s?.streetNo] : [s?.streetNo, s?.street])
      .filter(Boolean)
      .join(' ')
      .trim();

    if (!streetPart) return undefined;

    const cityPostal = [s?.city, s?.postalCode].filter(Boolean).join(' ');
    return [streetPart, cityPostal].filter(Boolean).join(', ');
  }

  return (
    <>
      {config?.order?.guest?.enabled && !User.getValue() ? (
        <GuestAddAddress responsiveLogo={responsiveLogo} />
      ) : (
        <DeliveryServices
          listAddress={addresses}
          addAddress={t('add_address')}
          list={menuList}
          setSelectedAddress={setSelectedUserAddressIndex}
          selectedIndex={selectedUserAddressIndex}
          onAddClick={() => {
            // SideSheetStore.close();
            AddressViewSideSheetStore.open();
          }}
        />
      )}
    </>
  );
}
